import { Alert, Button,  Snackbar, TextField } from '@mui/material';
import { doc, getDoc, onSnapshot, updateDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import { useNavigate, useParams } from 'react-router-dom';
import './game.css';

function GuestName() {
    const [name, setName] = useState('');
    const { documentId } = useParams();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [isTriviaOn, setIsTriviaOn] = useState(false);
    const navigate = useNavigate();

    
  useEffect(() => {

    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {

      const data = doc.data();

      setIsTriviaOn(data.isOn)

    });

    return () => unsub();

  }, []);


    useEffect(() => {
        const fetchGuestData = async () => {
            try {
                const guestDocRef = doc(db, 'guest', documentId);
                const guestDocSnap = await getDoc(guestDocRef);

                if (guestDocSnap.exists()) {
                    const guestData = guestDocSnap.data();
                    setName(guestData.name || '');
                } else {
                    //setError('Guest not found');
                }
            } catch (error) {
                console.error('Error fetching guest data:', error);
                //setError('Failed to fetch guest data');
            } finally {
                //setLoading(false);
            }
        };

        fetchGuestData();
    }, [documentId]);

    const handleSave = async (event) => {
        event.preventDefault(); // Prevents the default form submission behavior

        const updatedGuest = {
            name: name.trim(),
        };

        const guestDocRef = doc(db, 'guest', documentId);
        await updateDoc(guestDocRef, updatedGuest);

        setShowSnackbar(true);
    };

    const handleSnackbarClose = () => {
        setShowSnackbar(false);
    };

    return (
        <div className="game-shell">
          <div className="guest-page">
            <div className="guest-hero">
              <div className="party-sign party-sign-small">
                <span>Desi</span>
                <strong>50+</strong>
              </div>
              <div>
                <p className="game-kicker">Desi Couples Trivia Night</p>
                <h1 className="guest-title">Player Name</h1>
              </div>
            </div>
            <div className="guest-name-card">
            <div className="guest-card-header">
              <span className="guest-pass-label">Party Pass</span>
              <span className="guest-pass-dots" aria-hidden="true"></span>
            </div>
            <h2>Update your display name</h2>
            <p>Each person plays individually. Couple totals can be added manually at the end.</p>
            <TextField
                label="Your Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                inputProps={{ maxLength: 48 }}
                fullWidth
            />
            <div className="guest-actions">
              <Button className="party-primary-button" variant="contained" onClick={handleSave}>
                  Save Name
              </Button>
              {isTriviaOn && <Button variant="outlined" onClick={()=>{navigate(`/guest-questions/${documentId}`)}}>
                Go To Trivia
              </Button>}
            </div>

            <Snackbar
                open={showSnackbar}
                autoHideDuration={10000}
                onClose={handleSnackbarClose}
                message="Save successful!"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Save successful!
                </Alert>
            </Snackbar>
            </div>
          </div>
        </div>
    )
}

export default GuestName

